import colors from '@/utils/colors';

export default {
  data() {
    return {
      pendingColor: colors.statusColor.pending,
      openedColor: colors.statusColor.opened,
      holdingColor: colors.statusColor.holding,
      repliedColor: colors.statusColor.replied,
      closedColor: colors.statusColor.closed,
      ignoredColor: colors.statusColor.ignored,
      pendingLabel: 'Pendente',
      openedLabel: 'Aberto',
      holdingLabel: 'Em Espera',
      repliedLabel: 'Respondido',
      closedLabel: 'Fechado',
      ignoredLabel: 'Ignorado',
      values: [
        'opened',
        'pending',
        'holding',
        'replied',
        'closed',
        'ignored',
      ],
    };
  },
  methods: {
    getAll() {
      return this.values.map(value => {
        const obj = this.getStatusObj(value);
        return {
          ...obj,
          value,
        };
      });
    },
    getStatusObj(title) {
      return {
        color: this[`${title}Color`],
        name: this[`${title}Label`],
      };
    },
    // eslint-disable-next-line complexity
    getStatusColorAndName(title) {
      switch (title.toLowerCase()) {
      case 'pending':
      case 'pendente':
        return this.getStatusObj('pending');
      case 'open':
      case 'opened':
      case 'aberto':
        return this.getStatusObj('opened');
      case 'waiting':
      case 'holding':
      case 'em espera':
        return this.getStatusObj('holding');
      case 'replied':
      case 'respondido':
        return this.getStatusObj('replied');
      case 'finished':
      case 'closed':
      case 'fechado':
        return this.getStatusObj('closed');
      case 'ignored':
      case 'ignorado':
      default:
        return this.getStatusObj('ignored');
      }
    },
  },
};
